(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("image-viewer-vue", [], factory);
	else if(typeof exports === 'object')
		exports["image-viewer-vue"] = factory();
	else
		root["image-viewer-vue"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition